export default __webpack_public_path__ + "static/media/groupmember.abc0ca5a.svg";